import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ label, title, description, center = false }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : "mx-auto text-center md:mx-0 md:text-left"}`}>
    <Reveal>
      <span className="uppercase tracking-[0.2em] text-xs font-bold text-violet-700" data-testid={`section-label-${label}`}>
        {label}
      </span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-heading font-extrabold tracking-tight text-slate-900 text-2xl sm:text-3xl lg:text-4xl leading-tight mt-4">
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className="text-slate-600 leading-relaxed text-sm sm:text-base mt-4">{description}</p>
      </Reveal>
    )}
  </div>
);
